var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.filter.options),function(option,index){return _c('w-checkbox',{key:'option_' + index,attrs:{"model":_vm.schema.$in,"value":option.value,"title":option.text},on:{"input":function($event){return _vm.$emit('update')}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }